import { render, staticRenderFns } from "./bf-help-text.vue?vue&type=template&id=be2043c4&"
import script from "./bf-help-text.vue?vue&type=script&lang=js&"
export * from "./bf-help-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports